<template>
    <div :style="wrapperStyle">
        <form class="searchform form-horizontal" v-on:submit.prevent="generateRoute">
            <div class="row pb-3" v-if="introText">
                <div class="col intro-text">
                    {{introText}}
                </div>
            </div>
            <div class="form-group row" v-if="showRadioButtons">
                <div class="col-sm-12">
                    <div class="form-check form-check-inline">
                        <b-form-input class="form-check-input" type="radio" name="circularTrail" id="inlineRadio1" v-bind:value="true"  v-model="circularTrail" />
                        <label class="form-check-label" for="inlineRadio1">Explore around an area</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <b-form-input class="form-check-input" type="radio" name="circularTrail" id="inlineRadio2" v-bind:value="false"  v-model="circularTrail" />
                        <label class="form-check-label" for="inlineRadio2">Explore from A to B</label>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <!--<label class="col-sm-2 col-form-label" for="fromAddress">{{fromLabel}}</label>-->
                <div class="col-sm-12">
<!--                    <client-only>-->
                        <!--          <input class="form-control" type="search" ref="refFromAddress" id="fromAddress" v-bind:disabled="startPoiName" v-bind:placeholder="fromPlaceholder" v-model="fromAddress"/>-->
                        <AddressSearchField :disabled="gotStartPoi" v-model="fromAddress" id="fromAddress" ref="refFromAddress" v-on:got-address="fromAddressSelected" :placeholder="fromPlaceholder" suggest-addresses-first="true"></AddressSearchField>
<!--                    </client-only>-->
                </div>
            </div>
            <transition name="fade" mode="out-in">
                <div class="form-group row" v-if="displayAToB">
                    <!--<label class="col-sm-2" for="toAddress">{{toLabel}}</label>-->
                    <div class="col-sm-12">
                        <!--          <input type="search" id="toAddress" ref="refToAddress" class="form-control mb-2 " v-bind:disabled="circularTrail" placeholder="Going to" v-model="toAddress"/>-->
<!--                        <client-only>-->
                            <AddressSearchField v-model="toAddress" :disabled="circularTrail" id="toAddress" ref="refToAddress" v-on:got-address="toAddressSelected" placeholder="Going to" suggest-addresses-first="true"></AddressSearchField>
<!--                        </client-only>-->
                    </div>
                </div>
            </transition>
            <div class="form-group row" v-if="showMeander">
                <div class="col-sm-6">
                    <b-form-input
                            type="range"
                            style="padding-left: 10px;"
                            id="meanderSlider"
                            v-model="meanderCode"
                            :value="40"
                            :step="20"
                            :ticks="[0, 100]"
                            :ticks_positions="[0, 100]"
                    />
                    <!--          <b-form-slider style="padding-left: 10px;" id="meanderSlider" v-model="meanderCode" :value="40" :step="20" :ticks="[0, 100]" :ticks_positions="[0, 100]"/>-->
                </div>
                <div class="col-sm-6" >
                    <label> <!-- for="meanderSlider" --> <!--v-bind:class="{ meanderSliderLabelGreyed: circularTrail}"-->{{meanderCodeWord}}</label> <!-- TODO: to fix tooltips: https://github.com/seiyria/bootstrap-slider/issues/689 -->
                </div>
            </div>
            <div class="row">
                <b-col cols="2" md="3">
                    <div>
                        <a href="https://www.greentalklabs.com/" target="_blank">
                            <img src="../assets/gt-logo-white.png" style="width:100px;"/>
                        </a>
                    </div>
                </b-col>
                <b-col cols="10" md="9">
                    <div class="d-flex flex-column align-items-end">
                        <transition name="fade">
                            <div v-show="aboveButtonErrorMessage" class="small text-danger">{{aboveButtonErrorMessage}}</div>
                        </transition>
                        <b-button @click="generateRoute()"
                                  size="md"
                                  variant="primary"
                                  :disabled="greyButtonUntilOK && computedInsufficientInput"
                        >
                            <span v-if="!working">Go!</span><b-spinner v-if="working" small></b-spinner>
                        </b-button>
                        <template v-if="displayAToB===false">
                            <b-link @click="switchMode('SHOW_A2B')" class="mode-switch" :class="switchClass">Or generate a {{trailTerm}} from {{startPoiName ? startPoiName : 'A'}} to {{startPoiName ? 'somewhere else' : 'B'}}</b-link>
                        </template>
                        <template v-if="displayAToB===true">
                            <b-link @click="switchMode('SHOW_CIRCULAR')" class="mode-switch" :class="switchClass">Or generate a circular {{trailTerm}}{{startPoiName ? ` around ${startPoiName}` : ''}}</b-link>
                        </template>
                    </div>
                </b-col>
            </div>
            <div class="row">
                <b-col class="mt-3">
                    <a href="https://www.treetalk.co.uk/privacy" target="_blank" class="privacy-link">privacy - your search will be sent to TreeTalk London</a>
                </b-col>
            </div>
        </form>
    </div>
</template>

<script>

// ***************************************************************************************************
//    This is derived from the components/widgets/Generator.vue in the treetalk-website-v5 repository
// ***************************************************************************************************

import _config from '../config';
import AddressSearchField from './AddressSearchField';
import Generate from '../lib/Generate';

// styles are imported in style section and not needed here
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

// individual bootstrap components since not globally installing
// https://bootstrap-vue.org/docs#individual-components-and-directives
import {BButton, BFormInput, BLink, BSpinner, BCol} from 'bootstrap-vue';

export default {
    name: "TreeTalkEmbeddableGenerator",
    components: {
        AddressSearchField,

        // https://bootstrap-vue.org/docs#individual-components-and-directives
        'b-button': BButton,
        'b-link': BLink,
        'b-form-input': BFormInput,
        'b-spinner': BSpinner,
        'b-col': BCol,
    },
    data() {
        return (
            {
                circularTrail: true, // mode, default is circular enabled
                fromPlaceholder: this.defaultFromPlaceholder, // placeholder for empty field overidden when startType='POI' and startPoiName is set
                fromAddress: null, // as typed in (just the characters typed in initially)
                toAddress: null, // as typed in
                fromAddressLat: null, // Calculated by the Place search when search, or set from POI Lat when startType='POI'
                fromAddressLon: null, // ditto
                toAddressLat: null,
                toAddressLon: null,
                meanderCode: this.defaultMeanderCode, // initialise from props
                working: false, // button pressed to generate
                aboveButtonErrorMessage: null,

                displayAToB: this.showAToB, // initialised from the param and toggled as user changes the mode. (Done cos you should not mutate props)
            }
        );
    },
    props: {
        'introText': {
            type: String,
            default: '',
            required: false,
        },
        'startType': {
            type: String,
            default: 'address',
            required: false,
        }, // one of address, POI
        'startPoiName': {
            type: String,
            default: undefined,
            required: false,
        }, // name of the start PoI - if set then the user is not selecting start location
        'startPoiLat': {
            type: Number,
            default: undefined,
            required: false,
        },
        'startPoiLon': {
            type: Number,
            default: undefined,
            required: false,
        },
        'dontSetFocus': {
            type: Boolean,
            default: false,
            required: false,
        }, // if set then will not set focus into the input box on display - use to prevent page scroll down
        // to the widget if below the break
        // if do not show radio buttons then we show switch options below the generate button
        'showRadioButtons': {
            type: Boolean,
            default: false,
            required: false,
        },
        'showAToB': { // initial state of whether show the A-B fields or just single circular field. Initialises displayAToB data item.
            type: Boolean,
            default: false,
            required: false,
        },
        'showMeander': {
            type: Boolean,
            default: false,
            required: false,
        },
        'defaultMeanderCode': {
            type: Number,
            default: 40,
            required: false,
        },
        'defaultFromPlaceholder': {
            type: String,
            default: 'Start typing your address',
            required: false,
        },
        'greyButtonUntilOK': {
            type: Boolean,
            default: true,
            required: false,
        },
        'trailTerm': {
            type: String,
            default: 'trail',
            required: false,
        },
        'switchClass': {
            type: String,
            default: 'generator-switch-link',
            required: false,
        },
        'backgroundColour': {
            type: String,
            default: null,
            required: false,
        },
        'maxWidth': {
            type: Number,
            default: null,
            required: false,
        }
    },
    watch: {
        startPoiType: function () {
            // should not change within a component but just incase
            this.refreshStartAddress();
        },
        startPoiName: function (val) {
            // Runs when startPoiName changes - ie. when user clicks on a tree etc in the parent such as on Map page
            // I could not get this binding working here with startPoiName: () => {.....}
            // console.log('startPoiName changed', val);
            this.refreshStartAddress(val);
        },
        circularTrail: function (circular) {
            // form field greying happens in the template. This looks after other aspects
            // console.log('watch circulartrail', this.startPoiName, this.circularTrail);
            if (!this.startPoiName) {
                if (circular) {
                    // clear the to field
                    this.toAddress = '';
                    this.toAddressLat = null;
                    this.toAddressLon = null;
                }
                // set cursor focus
                // https://forum.vuejs.org/t/how-to-set-focus-to-input/10672/6
                // set cursor focus
                // refFromAddress is the VueJS "ref" set on the element in the template
                // TODO: this.$refs.refFromAddress.focus();
            } else {
                // eslint-disable-next-line no-lonely-if
                if (circular) {
                    // clear the to field
                    this.toAddress = '';
                    this.toAddressLat = null;
                    this.toAddressLon = null;
                }

                // set cursor focus
                // https://forum.vuejs.org/t/how-to-set-focus-to-input/10672/6
                // set cursor focus
                // refFromAddress is the VueJS "ref" set on the element in the template
                // TODO: getting error "Cannot read property 'focus' of undefined" this.$refs.refToAddress.focus();
                // console.log(this.$refs.refToAddress);
            }
        }
    },
    mounted () {
        // console.log('TreeTalkEmbeddableGenerator: mounted');
        var that = this;

        // set cursor focus
        // Note if the widget is off the page this will cause it to scroll until this field is visible
        // https://forum.vuejs.org/t/how-to-set-focus-to-input/10672/6
        this.$nextTick(() => {
            if (!that.dontSetFocus) {
                if (!that.startPoiName) {
                    // TODO: getting error "Cannot read property 'focus' of undefined" that.$refs.refFromAddress.focus();
                } else {
                    // TODO: getting error "Cannot read property 'focus' of undefined" that.$refs.refToAddress.focus();
                }
            }
        });

        // Initialise the
        this.refreshStartAddress(this.startPoiName);
    },
    methods: {
        switchMode(newMode) {
            // used from the switching link under the button but not bothered to use on the radio button
            if (newMode === 'SHOW_CIRCULAR') {
                this.circularTrail = true;
                this.displayAToB = false;
            } else if (newMode === 'SHOW_A2B') {
                this.circularTrail = false;
                this.displayAToB = true;
            }
        },
        fromAddressSelected(fromAddress) {
            this.fromAddress = fromAddress.address;
            this.fromAddressLat = fromAddress.addressLat;
            this.fromAddressLon = fromAddress.addressLon;
        },
        toAddressSelected(toAddress) {
            this.toAddress = toAddress.address;
            this.toAddressLat = toAddress.addressLat;
            this.toAddressLon = toAddress.addressLon;
        },
        refreshStartAddress: function () {
            // Sets the from address if the parent is using a start from POI option and it changes which POI is selected
            // console.log('refresh', val, this.startType, this.startPoiName);
            if (this.startType === 'POI' && this.startPoiName) {
                this.fromPlaceholder = this.startPoiName;
                this.fromAddressLat = this.startPoiLat;
                this.fromAddressLon = this.startPoiLon;
            }
        },
        makeInfoToast(title, message) {
            // if (process.client) {
            //     this.$bvToast.toast(message, {
            //         title: title,
            //         autoHideDelay: 7000,
            //         variant: 'info'
            //     })
            // }
            this.aboveButtonErrorMessage = `${title}: ${message}`;
        },
        generateRoute: function () { // this is not right if use the () => { .... } form, though it should be bound to the parental this :(
            // console.log (`generateRoute ${this.fromAddress} ${this.fromAddressLat} ${this.fromAddressLon} -> ${this.toAddress} ${this.toAddressLat} ${this.toAddressLon}`);
            const that = this;
            // reset if had been set by previous bad input
            this.aboveButtonErrorMessage = null;

            // The start address is either tree or user selected address
            if (this.startPoiName) {
                var fromAddressToUse = this.startPoiName.replace('This ', 'a '); // Little hacky to change from "This Ginkgo" to "a Gingko"
            } else {
                // Check got everything need
                if (!this.greyButtonUntilOK) {
                    if (this.computedInsufficientInput) {
                        this.aboveButtonErrorMessage = `Please search for & select a start address${this.circularTrail ? '.' : ' and end address.'}`;
                        return;
                    }
                }
                fromAddressToUse = this.fromAddress;
            }

            this.working = true;

            const ROUTE_TYPE = 'species20'; // set to null for lib default route type (which is 'species' == species unique trail)
            Generate.generate(this.fromAddressLat, this.fromAddressLon, this.toAddressLat, this.toAddressLon, ROUTE_TYPE, this.meanderCode, fromAddressToUse, this.toAddress )
                .then(routeGuid => {
                    // Open Route page for this route id. The trees and pois are still being generated in the background on the server
                    // so may want a small animation / delay here
                    // Returns success if can create a trail or insufficient data to create a trail
                    if (routeGuid) {
                        that.working = false;
                        // Jump to website to view route. No router and not a SPA so just open tab
                        // that.$router.push({name: 'route-routeGuid', params: {routeGuid: routeGuid}});
                        // Do not use _blank target as otherwise popup blockers can be triggered
                        // TODO: some ways around this popup block issue if can get the open to be triggered by the user button press and then the route to appear in that opened window
                        // though that may have issues with clean display of the error message when a route cannot be created in that area
                        // see https://stackoverflow.com/a/25050893
                        window.open (`${_config.treeTalkWebsite}/route/${routeGuid}`, '_self');
                    } else {
                        // Occurs if cannot find sufficient items to make a trail (which is something we have subsequently made less fussy)
                        console.log('No trail can be created.');
                        that.working = false;
                        that.makeInfoToast('Sorry', `There are not enough trees known around this area to create a ${this.trailTerm}. Please check the Tree Map for areas with trees.`);
                    }
                })
                .catch(err => {
                    console.log('No trail can be created.', err);
                    that.working = false;
                    that.makeInfoToast('Sorry', `There was an error while trying to create this ${this.trailTerm}. Please try again later, or try a different area.`);
                });
        },
    },
    computed: {
        gotStartPoi: function () {
            // Not easy to use a string as boolean in the template so convert here
            //   empty string is truthy
            if (this.startPoiName && this.startPoiName !== '') {
                return true;
            } else {
                return false;
            }
        },
        meanderCodeWord: function () {
            const words = {
                0: 'Go directly',
                20: 'Go mostly direct',
                40: 'Go a bit off track',
                60: 'Do some wandering',
                80: 'Do light exploration',
                100: 'Do deep exploration'
            };
            return words[this.meanderCode];
        },
        fromLabel: function () {
            return (this.circularTrail ? 'Around' : 'From');
        },
        toLabel: function () {
            return (this.circularTrail ? 'To' : 'To');
        },
        computedInsufficientInput: function () {
            if (this.circularTrail) {
                return (!this.fromAddressLat);
            } else {
                return (!this.fromAddressLat || !this.toAddressLat);
            }
        },
        wrapperStyle () {
            // The styling of the outer wrapper being controlled by input properties
            // This is (mostly) used when Generator is being embedded in SanityIO PortableText by the Studio editor. Normally the including code can control these itself
            let backgroundColour = this.backgroundColour ? {backgroundColor: this.backgroundColour} : {};
            let maxWidth = this.maxWidth ? {maxWidth: `${this.maxWidth}px`} : {};
            let padding = backgroundColour ? {padding: '9px'} : {};
            return {
                ...backgroundColour,
                ...maxWidth,
                ...padding
            };
        }
    }
}
</script>

<style scoped>
.searchform {
    /* initial otherwise inherits fonts set for the sidebar */
    /*color: #767272;*/
    font-size: initial;
}
#circularTrail {
}
</style>

<style lang="scss">
// Must import these otherwise they are not accessible in this shadow dom
// See https://medium.com/javascript-in-plain-english/how-to-create-web-components-with-vue-js-25cd8d7dfd47
@import "../../node_modules/bootstrap/dist/css/bootstrap.css";
@import "../../node_modules/bootstrap-vue/dist/bootstrap-vue.css";

$gtgreeng1: #215f2b;
$gtgreene2: #26793c;
$gtgreenk1: #2fac66;

// Bootstrap overrides - button colour is lighter TreeTalk green as box background is darker TreeTalk green
.btn-primary {
    color: #fff;
    background-color: $gtgreenk1!important;
    border-color: $gtgreenk1!important;
}

// Fonts
@import url('https://fonts.googleapis.com/css2?family=Raleway&display=swap');
* {
    font-family: 'Raleway', sans-serif;
}

.privacy-link, .privacy-link:visited, .privacy-link:link {
    font-size: 0.8em;
    color: white;
    line-height: 0.8; // important for if it wraps
}
.privacy-link, .privacy-link:visited, .privacy-link:link {
    // make it clear it is a clickable link on mobile (it is white same colour as text so not visible as such if no hover)
    text-decoration: underline;
}
// off on desktop
@media screen and (min-width: 768px) {
    .privacy-link, .privacy-link:visited, .privacy-link:link {
        text-decoration: none;
    }
}
// on (wider) underline on hover
.privacy-link:hover {
    text-decoration: underline;
}

/* default for the switch under the button */
.generator-switch-link {
    color: white;
    // make it clear it is a clickable link on mobile (it is white same colour as text so not visible as such if no hover)
    text-decoration: underline;
}
@media screen and (min-width: 768px) {
    .generator-switch-link {
        text-decoration: inherit;
    }
}
a.generator-switch-link:hover {
    color: white;
}

/* filled in bar */
.slider-selection.tick-slider-selection {
    background-image: -webkit-gradient(linear, left top, left bottom, from(#aeef8a), to(#b2de82)) !important;
    background-image: linear-gradient(to bottom, #aeef8a 0%, #b2de82 100%) !important;
}
/* start blob */
.slider-tick.in-selection {
    background-image: -webkit-gradient(linear, left top, left bottom, from(#a5c246), to(#c3f56c)) !important;
    background-image: linear-gradient(to bottom, #a5c246 0%, #c3f56c 100%) !important;
}
.slider-handle {
    background-color: #a5c246 !important;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#a5c246), to(#c3f56c)) !important;
    background-image: linear-gradient(to bottom, #a5c246 0%, #c3f56c 100%) !important;
}
/* could not get this to work to grey out all aspects so left for now
.meanderSliderLabelGreyed {
  color: rgba(157, 157, 157, 0.33) !important;
}
*/
.mode-switch {
    /*font-size: 0.9em;*/
    padding-left: 18px;
    margin-top: 1rem;
}
.small {
    font-size: 0.9em;
    /*padding-left: 18px;*/
}
.intro-text {
    line-height: 1.5em;
}

// the transition for error message and a-b field appearing
.fade-enter-active, .fade-leave-active {
    transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>

